import { SxProps, Typography } from '@mui/material';

/** custom, but not sure if we have this in our theme and this is a one-off - only one in the application */
export const HEADER_SX_PROPS: SxProps = {
  fontSize: '15px',
  fontWeight: 400,
  pl: 1,
  py: 1,
};

export const HeaderTextBox: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Typography component="span" sx={HEADER_SX_PROPS}>
      {children}
    </Typography>
  );
};
